var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21.301,
    viewBox: "0 0 21 21.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_nota",
    "data-name": "icona nota",
    transform: "translate(-740 -97.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_nota-2",
    "data-name": "icona nota",
    transform: "translate(-527.5 -249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2208",
    "data-name": "Raggruppa 2208",
    transform: "translate(1269 347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_336",
    "data-name": "Tracciato 336",
    d: "M11.75,3.5A1.75,1.75,0,1,1,13.5,1.75,1.752,1.752,0,0,1,11.75,3.5Zm0-2.625a.875.875,0,1,0,.875.875A.876.876,0,0,0,11.75.875Z",
    transform: "translate(-2.75)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_333",
    "data-name": "Tracciato 333",
    d: "M13.875,25.438h-12C.841,25.438,0,24.232,0,22.749V7.689C0,6.206.841,5,1.875,5H5.859c.207,0,.375.241.375.538s-.192.538-.4.538H1.875C1.255,6.076.75,6.8.75,7.689v15.06c0,.89.5,1.614,1.125,1.614H13.72L17.25,19.3V7.689c0-.89-.5-1.614-1.125-1.614H12.164c-.207,0-.328-.241-.328-.538S12,5,12.211,5h3.914C17.158,5,18,6.206,18,7.689V19.522a.679.679,0,0,1-.109.381l-3.75,5.379A.332.332,0,0,1,13.875,25.438Zm3.75-5.916h.007Z",
    transform: "translate(0 -4.438)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_334",
    "data-name": "Tracciato 334",
    d: "M18.514,23.25A.481.481,0,0,1,18,22.813V18.438A.481.481,0,0,1,18.514,18h5.143a.443.443,0,1,1,0,.875H19.029v3.938A.481.481,0,0,1,18.514,23.25Z",
    transform: "translate(-6.172 -2.25)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_335",
    "data-name": "Tracciato 335",
    d: "M12.014,8.25a.481.481,0,0,1-.514-.438V3.438a.521.521,0,0,1,1.029,0V7.813A.481.481,0,0,1,12.014,8.25Z",
    transform: "translate(-3.014 -0.375)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_337",
    "data-name": "Tracciato 337",
    d: "M14.25,14.932H3.75a.717.717,0,1,1,0-1.432h10.5a.717.717,0,1,1,0,1.432Z",
    transform: "translate(1269 346.386)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_338",
    "data-name": "Tracciato 338",
    d: "M14.25,10.932H3.75a.717.717,0,1,1,0-1.432h10.5a.717.717,0,1,1,0,1.432Z",
    transform: "translate(1269 346.567)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_339",
    "data-name": "Tracciato 339",
    d: "M6.961,6.932H3.75a.717.717,0,1,1,0-1.432H7.086a.734.734,0,0,1,.75.716A.856.856,0,0,1,6.961,6.932Z",
    transform: "translate(1269 346.75)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_781",
    "data-name": "Rettangolo 781",
    transform: "translate(740 98)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.fc34817ed5eece624d59ef3c4e6ab45f.svg";
export { ForwardRef as ReactComponent };